module.exports = __webpack_public_path__ + "static/media/s5.50bd1e1a.png";